/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вью для затемнения экрана под попапом.
   */
  app.FaderView = app.FaderBaseView.extend({
    el: '#js-screen-overlay',

    /**
     * Переключение состояния затемнения
     * @param state {Boolean} true - показан
     *                        false - скрыт
     */
    toggle: function (state) {
      if (!_.isUndefined(state)){
        state = !state;
      }
      this.$el.toggleClass('not_display', state);
    },

    show: function () {
      this.$el.removeClass('not_display');
    },

    hide: function () {
      this.$el.addClass('not_display');
    }
  });

})();

}.call(window));